import * as Types from '../../types.generated';

import { api } from '../../rootApi';
export type PlanQueryVariables = Types.Exact<{ [key: string]: never }>;

export type PlanQuery = {
  __typename?: 'Query';
  plans: Array<{
    __typename?: 'Plan';
    currency?: string | null | undefined;
    currencySymbol?: string | null | undefined;
    description?: string | null | undefined;
    durationInDays: number;
    id: number;
    name: string;
    paymentType: Types.Payment;
    price: number;
    rzpPlanId?: string | null | undefined;
  }>;
};

export type PlanProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;

export type PlanProfileQuery = {
  __typename?: 'Query';
  planProfile: {
    __typename?: 'Plan';
    currency?: string | null | undefined;
    currencySymbol?: string | null | undefined;
    description?: string | null | undefined;
    durationInDays: number;
    id: number;
    name: string;
    paymentType: Types.Payment;
    price: number;
  };
};

export type PaymentCreateTransactionMutationVariables = Types.Exact<{
  subscriptionPlanId: Types.Scalars['Int'];
  couponCode?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type PaymentCreateTransactionMutation = {
  __typename?: 'Mutation';
  paymentCreateTransaction: {
    __typename?: 'Transaction';
    amountCents: number;
    currency?: string | null | undefined;
    id: number;
    rzpOrderId?: string | null | undefined;
    status: Types.TransactionStatus;
  };
};

export type PaymentCreateSubscriptionMutationVariables = Types.Exact<{
  subscriptionPlanId: Types.Scalars['Int'];
  couponCode?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type PaymentCreateSubscriptionMutation = {
  __typename?: 'Mutation';
  paymentCreateSubscription: {
    __typename?: 'Transaction';
    amountCents: number;
    currency?: string | null | undefined;
    id: number;
    rzpSubscriptionId?: string | null | undefined;
    status: Types.TransactionStatus;
  };
};

export type PaymentVerifyTransactionMutationVariables = Types.Exact<{
  rzpOrderId: Types.Scalars['String'];
}>;

export type PaymentVerifyTransactionMutation = {
  __typename?: 'Mutation';
  paymentVerifyTransaction: {
    __typename?: 'Subscription';
    expiresAt: any;
    id: number;
    isActive: boolean;
    subscriptionPlan: { __typename?: 'Plan'; id: number; name: string };
  };
};

export type PaymentVerifySubscriptionMutationVariables = Types.Exact<{
  rzpSubscriptionId: Types.Scalars['String'];
}>;

export type PaymentVerifySubscriptionMutation = {
  __typename?: 'Mutation';
  paymentVerifySubscription: {
    __typename?: 'Subscription';
    expiresAt: any;
    id: number;
    isActive: boolean;
    subscriptionPlan: { __typename?: 'Plan'; id: number; name: string };
  };
};

export type PaymentCancelSubscriptionMutationVariables = Types.Exact<{
  subscriptionId: Types.Scalars['Int'];
}>;

export type PaymentCancelSubscriptionMutation = {
  __typename?: 'Mutation';
  paymentCancelSubscription: {
    __typename?: 'Subscription';
    expiresAt: any;
    id: number;
    isActive: boolean;
    renewalPolicy?: Types.SubscriptionRenewalPolicy | null | undefined;
    subscriptionPlan: { __typename?: 'Plan'; id: number; name: string };
  };
};

export type CreateGiftTransactionMutationVariables = Types.Exact<{
  subscriptionPlanId: Types.Scalars['Int'];
  senderName: Types.Scalars['String'];
  senderEmail: Types.Scalars['String'];
  receiverName: Types.Scalars['String'];
  receiverEmail: Types.Scalars['String'];
}>;

export type CreateGiftTransactionMutation = {
  __typename?: 'Mutation';
  createGiftTransaction: {
    __typename?: 'Transaction';
    amountCents: number;
    appleTransactionId?: string | null | undefined;
    createdAt: any;
    currency?: string | null | undefined;
    id: number;
    isGift: boolean;
    rzpOrderId?: string | null | undefined;
    rzpSubscriptionId?: string | null | undefined;
    status: Types.TransactionStatus;
    subscription?:
      | {
          __typename?: 'Subscription';
          createdAt: any;
          expiresAt: any;
          id: number;
          isActive: boolean;
          renewalPolicy?: Types.SubscriptionRenewalPolicy | null | undefined;
          subscriptionPlan: { __typename?: 'Plan'; id: number; name: string };
        }
      | null
      | undefined;
  };
};

export type RedeemGiftTransactionMutationVariables = Types.Exact<{
  giftCode: Types.Scalars['String'];
}>;

export type RedeemGiftTransactionMutation = {
  __typename?: 'Mutation';
  redeemGiftTransaction: {
    __typename?: 'Subscription';
    createdAt: any;
    expiresAt: any;
    id: number;
    isActive: boolean;
    renewalPolicy?: Types.SubscriptionRenewalPolicy | null | undefined;
    subscriptionPlan: {
      __typename?: 'Plan';
      currency?: string | null | undefined;
      currencySymbol?: string | null | undefined;
      description?: string | null | undefined;
      durationInDays: number;
      id: number;
      name: string;
      paymentType: Types.Payment;
      price: number;
      rzpPlanId?: string | null | undefined;
    };
  };
};

export type VerifyGiftTransactionMutationVariables = Types.Exact<{
  rzpOrderId: Types.Scalars['String'];
}>;

export type VerifyGiftTransactionMutation = {
  __typename?: 'Mutation';
  verifyGiftTransaction: {
    __typename?: 'Transaction';
    amountCents: number;
    appleTransactionId?: string | null | undefined;
    createdAt: any;
    currency?: string | null | undefined;
    id: number;
    isGift: boolean;
    rzpOrderId?: string | null | undefined;
    rzpSubscriptionId?: string | null | undefined;
    status: Types.TransactionStatus;
    subscription?:
      | {
          __typename?: 'Subscription';
          createdAt: any;
          expiresAt: any;
          id: number;
          isActive: boolean;
          renewalPolicy?: Types.SubscriptionRenewalPolicy | null | undefined;
          subscriptionPlan: { __typename?: 'Plan'; id: number };
        }
      | null
      | undefined;
  };
};

export const PlanDocument = `
    query plan {
  plans {
    currency
    currencySymbol
    description
    durationInDays
    id
    name
    paymentType
    price
    rzpPlanId
  }
}
    `;
export const PlanProfileDocument = `
    query planProfile($id: Int!) {
  planProfile(id: $id) {
    currency
    currencySymbol
    description
    durationInDays
    id
    name
    paymentType
    price
  }
}
    `;
export const PaymentCreateTransactionDocument = `
    mutation paymentCreateTransaction($subscriptionPlanId: Int!, $couponCode: String) {
  paymentCreateTransaction(
    subscriptionPlanId: $subscriptionPlanId
    couponCode: $couponCode
  ) {
    amountCents
    currency
    id
    rzpOrderId
    status
  }
}
    `;
export const PaymentCreateSubscriptionDocument = `
    mutation paymentCreateSubscription($subscriptionPlanId: Int!, $couponCode: String) {
  paymentCreateSubscription(
    subscriptionPlanId: $subscriptionPlanId
    couponCode: $couponCode
  ) {
    amountCents
    currency
    id
    rzpSubscriptionId
    status
  }
}
    `;
export const PaymentVerifyTransactionDocument = `
    mutation paymentVerifyTransaction($rzpOrderId: String!) {
  paymentVerifyTransaction(rzpOrderId: $rzpOrderId) {
    expiresAt
    id
    isActive
    subscriptionPlan {
      id
      name
    }
  }
}
    `;
export const PaymentVerifySubscriptionDocument = `
    mutation paymentVerifySubscription($rzpSubscriptionId: String!) {
  paymentVerifySubscription(rzpSubscriptionId: $rzpSubscriptionId) {
    expiresAt
    id
    isActive
    subscriptionPlan {
      id
      name
    }
  }
}
    `;
export const PaymentCancelSubscriptionDocument = `
    mutation paymentCancelSubscription($subscriptionId: Int!) {
  paymentCancelSubscription(subscriptionId: $subscriptionId) {
    expiresAt
    id
    isActive
    renewalPolicy
    subscriptionPlan {
      id
      name
    }
  }
}
    `;
export const CreateGiftTransactionDocument = `
    mutation createGiftTransaction($subscriptionPlanId: Int!, $senderName: String!, $senderEmail: String!, $receiverName: String!, $receiverEmail: String!) {
  createGiftTransaction(
    gift: {subscriptionPlanId: $subscriptionPlanId, senderName: $senderName, senderEmail: $senderEmail, receiverName: $receiverName, receiverEmail: $receiverEmail}
  ) {
    amountCents
    appleTransactionId
    createdAt
    currency
    id
    isGift
    rzpOrderId
    rzpSubscriptionId
    status
    subscription {
      createdAt
      expiresAt
      id
      isActive
      renewalPolicy
      subscriptionPlan {
        id
        name
      }
    }
  }
}
    `;
export const RedeemGiftTransactionDocument = `
    mutation redeemGiftTransaction($giftCode: String!) {
  redeemGiftTransaction(giftCode: $giftCode) {
    createdAt
    expiresAt
    id
    isActive
    renewalPolicy
    subscriptionPlan {
      currency
      currencySymbol
      description
      durationInDays
      id
      name
      paymentType
      price
      rzpPlanId
    }
  }
}
    `;
export const VerifyGiftTransactionDocument = `
    mutation verifyGiftTransaction($rzpOrderId: String!) {
  verifyGiftTransaction(rzpOrderId: $rzpOrderId) {
    amountCents
    appleTransactionId
    createdAt
    currency
    id
    isGift
    rzpOrderId
    rzpSubscriptionId
    status
    subscription {
      createdAt
      expiresAt
      id
      isActive
      renewalPolicy
      subscriptionPlan {
        id
      }
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    plan: build.query<PlanQuery, PlanQueryVariables | void>({
      query: (variables) => ({ document: PlanDocument, variables }),
    }),
    planProfile: build.query<PlanProfileQuery, PlanProfileQueryVariables>({
      query: (variables) => ({ document: PlanProfileDocument, variables }),
    }),
    paymentCreateTransaction: build.mutation<
      PaymentCreateTransactionMutation,
      PaymentCreateTransactionMutationVariables
    >({
      query: (variables) => ({
        document: PaymentCreateTransactionDocument,
        variables,
      }),
    }),
    paymentCreateSubscription: build.mutation<
      PaymentCreateSubscriptionMutation,
      PaymentCreateSubscriptionMutationVariables
    >({
      query: (variables) => ({
        document: PaymentCreateSubscriptionDocument,
        variables,
      }),
    }),
    paymentVerifyTransaction: build.mutation<
      PaymentVerifyTransactionMutation,
      PaymentVerifyTransactionMutationVariables
    >({
      query: (variables) => ({
        document: PaymentVerifyTransactionDocument,
        variables,
      }),
    }),
    paymentVerifySubscription: build.mutation<
      PaymentVerifySubscriptionMutation,
      PaymentVerifySubscriptionMutationVariables
    >({
      query: (variables) => ({
        document: PaymentVerifySubscriptionDocument,
        variables,
      }),
    }),
    paymentCancelSubscription: build.mutation<
      PaymentCancelSubscriptionMutation,
      PaymentCancelSubscriptionMutationVariables
    >({
      query: (variables) => ({
        document: PaymentCancelSubscriptionDocument,
        variables,
      }),
    }),
    createGiftTransaction: build.mutation<
      CreateGiftTransactionMutation,
      CreateGiftTransactionMutationVariables
    >({
      query: (variables) => ({
        document: CreateGiftTransactionDocument,
        variables,
      }),
    }),
    redeemGiftTransaction: build.mutation<
      RedeemGiftTransactionMutation,
      RedeemGiftTransactionMutationVariables
    >({
      query: (variables) => ({
        document: RedeemGiftTransactionDocument,
        variables,
      }),
    }),
    verifyGiftTransaction: build.mutation<
      VerifyGiftTransactionMutation,
      VerifyGiftTransactionMutationVariables
    >({
      query: (variables) => ({
        document: VerifyGiftTransactionDocument,
        variables,
      }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  usePlanQuery,
  useLazyPlanQuery,
  usePlanProfileQuery,
  useLazyPlanProfileQuery,
  usePaymentCreateTransactionMutation,
  usePaymentCreateSubscriptionMutation,
  usePaymentVerifyTransactionMutation,
  usePaymentVerifySubscriptionMutation,
  usePaymentCancelSubscriptionMutation,
  useCreateGiftTransactionMutation,
  useRedeemGiftTransactionMutation,
  useVerifyGiftTransactionMutation,
} = injectedRtkApi;
